import Table from './Table.vue'
Table.install = Vue => Vue.component(Table.name, Table)
export default Table


// WEBPACK FOOTER //
// ./src/components/table/index.js